/**
 * Trace optionnelle des chargements produits (liste boutique).
 * Activer : localStorage.setItem('DEBUG_PRODUCTS', '1') puis recharger la page.
 * Désactiver : localStorage.removeItem('DEBUG_PRODUCTS') puis recharger.
 */

let diagSeq = 0;

export function isProductsDebugEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem('DEBUG_PRODUCTS') === '1';
  } catch {
    return false;
  }
}

export function logProductsDiag(message: string, data?: Record<string, unknown>): void {
  if (!isProductsDebugEnabled()) return;
  diagSeq += 1;
  if (data && Object.keys(data).length > 0) {
    console.log(`[PRODUCTS #${diagSeq}]`, message, data);
  } else {
    console.log(`[PRODUCTS #${diagSeq}]`, message);
  }
}

/** À n'utiliser qu'avec DEBUG_PRODUCTS : coûteux (stack). */
export function traceProductsHttp(label: string, payload: Record<string, unknown>): void {
  if (!isProductsDebugEnabled()) return;
  console.trace(`[PRODUCTS] ${label}`, payload);
}
